import React, { useContext } from "react"
import { StaticQuery, graphql } from "gatsby"
import { ContentfulLink, FooterQuery } from "../../types/graphql-types"
import LocaleContext from "../context/localeContext"
import Foot from "./Foot"
interface Props {
  isInverted?: boolean
}

export interface FooterProps extends Props {
  data: FooterQuery
  isInverted?: boolean
}

const Footer = ({ data, isInverted }: FooterProps) => {
  const locale = useContext(LocaleContext)
  const foot = data.footerData.nodes.find(item => item.node_locale === locale)

  return (
    <Foot
      links={foot?.links as ContentfulLink[]}
      isInverted={isInverted}
      description={foot?.description?.paragraph?.paragraph!}
    />
  )
}

export default (props: Props) => (
  <StaticQuery
    query={graphql`
      query Footer {
        footerData: allContentfulFooter(filter: { internalName: { eq: "Footer" } }) {
          nodes {
            node_locale
            description {
              ...Paragraph
            }
            links {
              ...Link
            }
          }
        }
      }
    `}
    render={data => <Footer data={data} {...props} />}
  />
)
